import { version } from '@Constants/BuildInfo';
import { localStorage } from '@Utils/Storage';
import { config } from '@Constants/rx-ui/constants';

const prefix = 'rx2:';

// eslint-disable-next-line import/prefer-default-export
export class AppStorage {
  static instance = new AppStorage();

  set(key, value) {
    return this._set(key, value, localStorage);
  }

  get(key) {
    return this._get(key, localStorage);
  }

  setToSessionStorage(key, value) {
    return this._set(key, value, sessionStorage);
  }

  getFromSessionStorage(key) {
    return this._get(key, sessionStorage);
  }

  removeFromSessionStorage(key) {
    return sessionStorage.removeItem(this._addPrefix(key));
  }

  remove(key) {
    return localStorage.removeItem(this._addPrefix(key));
  }

  clear = () => {
    return localStorage.clear();
  };

  getAll = () => {
    return localStorage;
  };

  cleanUp() {
    Object.keys(this.getAll()).forEach((key) => {
      if (key.indexOf(prefix) === 0 && key.indexOf(config.STATION_ID) < 0) {
        const parsedItem = this.get(key);
        if (parsedItem === null) {
          try {
            this.remove(key);
          } catch (e) {
            Logger.warn(`Attempt to remove localStorage key ${key} failed`);
          }
        }
      }
    });
  }

  _addPrefix = (str) => {
    return str.indexOf(prefix) !== 0 ? `rx2:${str}` : str;
  };

  _set(key, value, storage) {
    if (value === undefined || value === 'undefined') {
      return null;
    }

    const data = JSON.stringify({ c: value, v: version });
    return storage.setItem(this._addPrefix(key), data);
  }

  _get(key, storage) {
    const result = JSON.parse(storage.getItem(this._addPrefix(key)));
    if (result && result.c && result.v === version) {
      return result.c;
    }
    return null;
  }
}
